<template>
  <div class="all-directories">
    <div class="title">{{ $t('directory.allDirectory') }}</div>
  </div>
</template>

<script>
export default {
  name: 'AllDirectories',
}
</script>
